<mat-dialog-content
  class="mat-mdc-dialog-surface mdc-dialog__surface bg-[#FFFFFF] !w-[65vw] h-auto !rounded-none"
  style="
    overflow: visible;
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px;
  "
>
  <!-- Close Icon -->
  <div class="w-full flex justify-between items-center h-[57px] bg-[#F5F5F5]">
    <h2
      class="text-[#21252A] pl-[36px] text-[20px] font-bold items-center !mb-0"
    >
      Attach Documents
    </h2>

    <mat-icon
      mat-icon-button
      mat-dialog-close
      class="!text-[24px] !font-bold cursor-pointer !pr-[2rem]">
      close</mat-icon
    >
  </div>

  <div class="bg-[#FFFFFF] !py-[24px] !px-[10px] !pb-[0px] table-scroll">
    <p class="text-gray-600 !text-[16px] !ml-[25px]">
      Add your documents here, and you can upload up to 5 files Max
    </p>
    <div>
      <div
        class="flex flex-col items-center justify-center p-6 border-2 ml-[25px] mr-[25px] border-dashed h-auto border-gray-300 bg-[#F7F6FB] hover:bg-orange-500 hover:bg-opacity-10 cursor-pointer transition-all duration-300"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [class.bg-blue-50]="isDragging"
      >
        <button
          class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded-[3px] focus:outline-none"
          (click)="fileInput.click()"
        >
          Attach File
        </button>
        <p class="text-[15px] font-semibold text-[#21252A] !mb-0">
          Drag & Drop
        </p>
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          multiple
          hidden
        />
      </div>
    </div>
    <p class="text-gray-600 !text-[16px] !ml-[25px]">
      Only support .jpg, .png .svg, .pdf and zip files
    </p>
    <div class="mb-[10px]" *ngIf="files.length > 0">
      <!-- <h3 class="!font-semibold text-lg mb-2 !ml-[25px] font-Roboto !text-[18px]">
        Documents
      </h3> -->

      <ul class="mt-4 mr-[25px] h-[100px] overflow-y-auto">
        <li
          *ngFor="let file of files; let i = index"
          class="bg-gray-100 text-gray-700 border flex items-center px-4 py-2 mb-2 rounded-[3px] relative"
        >
          <div class="flex justify-between items-center w-[100%]">
            <div class="flex items-center">
              <!-- File Icon -->
             

              <div
                class="relative !mt-[3px] w-[1.5rem] h-[1.5rem] overflow-hidden"
              >
                <img
                  [src]="getFileIcon(file)"
                  alt="File Preview"
                  class="object-cover w-auto h-[100%] cursor-pointer"
                />
              </div>

              <div class="file-item">
                <span
                  *ngIf="!isEditing"
                  class="!min-w-[237px] !h-auto border border-gray-400 ml-[20px] p-[5px]"
                  (click)="startEditing(i)"
                  >{{ file.name }}</span
                >

                <input
                  *ngIf="isEditing"
                  [(ngModel)]="newFileName"
                  (blur)="saveFileName()"
                  (keydown.enter)="saveFileName()"
                />

                <!-- <button class="ml-[20px]" *ngIf="!isEditing">Edit</button> -->
                <!-- <button *ngIf="isEditing" (click)="cancelEditing()">Cancel</button> -->
              </div>

              <!-- Delete Button -->
              <button
                class="text-[#2368A2] ml-[10px] absolute right-[3px] top-[11px]"
                (click)="removeFile(i)"
              >
                <img src="assets/icons/close-icon.svg" alt="close-icon" />
              </button>
            </div>
            <div></div>
          </div>
        </li>
      </ul>
    </div>
    <!-- Additional section -->
    <div class="px-[25px]">
      <div class="mb-4">
        <label class="block text-[#343A40] font-semibold !text-[1rem] mb-2"
          >Drawing Set</label
        >
        <p class="text-[#6F6D6D] font-normal text-[14px] roboto mb-2">
          Group and label Drawings into a collection as they are issued to keep
          them organized.
        </p>
        <mat-form-field appearance="outline" class="w-full h-[66px]">
          <mat-label>Select or Create Set</mat-label>
          <mat-select
            [(value)]="selectedSet"
            class="!bg-white"
            (selectionChange)="onSelectionChange($event)"
            required
          >
            <div class="!bg-white">
              <input
                placeholder="Search sets..."
                [(ngModel)]="searchText"
                (input)="filterSets()"
                (keydown.space)="$event.stopPropagation()"
                class="px-[10px] w-full h-[2.5rem] !bg-[#ebebeb]"
              />
            </div>
            <mat-option *ngFor="let set of sets" [value]="set" class="!bg-white border-t hover:!bg-[#fae8e1]">
              {{ set?.set_name }}
            </mat-option>
            <!-- Show "Create New" button if no results are found -->
            <mat-option
             *ngIf="filteredSets.length === 0 && searchText.trim()" 
             (click)="addNewSets(searchText,project_id)"
              [value]="searchText"
              class="btnsticky !bg-white">
              <button class="w-full text-left bg-[#E76B3F] m-3 p-3 rounded-[4px] text-[#F1F3F5]">
                {{ searchText }}
              </button>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!selectedSet">Drawing Set is required</mat-error>
        </mat-form-field>
      </div>
      <!-- Set Date -->
      <div class="mb-4" *ngIf="selectedSet">
        <label class="block text-[1rem] font-semibold text-[#343A40] mb-2"
          >Set Date</label
        >

        <div class="relative">
          <mat-form-field appearance="outline" class="">
            <mat-label>Pick a Date</mat-label>
            <input
              matInput
              [matDatepicker]="setpicker"
              [formControl]="setDate"
              placeholder="mm/dd/yyyy"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="setpicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #setpicker></mat-datepicker>
            <!-- <mat-error *ngIf="setpicker.invalid && (setpicker.dirty || setpicker.touched)">
              Default Drawing Date is Required
            </mat-error> -->
          </mat-form-field>
        </div>
        <p class="text-gray-500 mt-2">
          Enter the date the Drawing was Authored
        </p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
        <div class="mb-4">
          <label class="block text-[1rem] font-semibold text-[#343A40] mb-2"
            >Default Drawing Date</label
          >

          <div class="relative">
            <mat-form-field appearance="outline" class="">
              <mat-label>Pick a Date</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                [formControl]="defaultDrawingDate"
                placeholder="mm/dd/yyyy"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="defaultDrawingDate.invalid && (defaultDrawingDate.dirty || defaultDrawingDate.touched)">
                Default Drawing Date is Required
              </mat-error>
            </mat-form-field>

            <button class="absolute right-2 top-2 text-gray-500">
              <i class="fas fa-calendar-alt"></i>
            </button>
          </div>
          <p class="text-gray-500 mt-2">
            Enter the date the Drawing was Authored
          </p>
        </div>
        <div class="mb-4">
          <label class="block text-[1rem] font-semibold text-[#343A40] mb-2"
            >Default Received Date</label
          >
          <div class="relative">
            <mat-form-field appearance="outline" class="">
              <mat-label>Pick a Date</mat-label>
              <input
                matInput
                [matDatepicker]="datepicker"
                [formControl]="publishDrawingDate"
                placeholder="mm/dd/yyyy"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
              <mat-error *ngIf="publishDrawingDate.invalid && (publishDrawingDate.dirty || publishDrawingDate.touched)">
                Publish Drawing Date is Requried
              </mat-error>
            </mat-form-field>

            <button class="absolute right-2 top-2 text-gray-500">
              <i class="fas fa-calendar-alt"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- Advanced options -->
      <div>
        <div class="flex">
          <mat-icon class="cursor-pointer" (click)="toggleAdvancedOptions()">{{
            isExpanded ? "expand_more" : "chevron_right"
          }}</mat-icon>
          <p class="block text-[1rem] font-semibold text-[#343A40] mb-2">
            Advanced Options
          </p>
        </div>
        <!-- Expandable -->
        <div *ngIf="isExpanded" class="pl-[0.5rem]">
          <label class="block text-[1rem] font-semibold text-[#343A40] mb-2"
            >Default Revision
          </label>
          <mat-form-field appearance="outline">
            <mat-label>Revision</mat-label>
            <input matInput type="number" [formControl]="revisions" />
          </mat-form-field>
          <label class="block text-[1rem] font-semibold text-[#343A40] mb-2">
            Drawing Number
          </label>

          <!-- Contain Revisions Checkbox -->
          <div class="flex">
            <input
              type="checkbox"
              class="mb-[10px] mr-[5px]"
              [formControl]="containRevisions"
            />
            <p class="text-[1rem]">Contain Revisions</p>
          </div>

          <!-- Get From Filename Checkbox -->
          <div class="flex">
            <input
              type="checkbox"
              class="mb-[10px] mr-[5px]"
              [formControl]="getFromFilename"
            />
            <p class="text-[1rem]">Get From Filename</p>
          </div>

          <div>
            <label class="block text-[1rem] font-semibold text-[#343A40] mb-2"
              >Drawing Language</label>

            <mat-form-field appearance="outline">
              <mat-label>Select Language</mat-label>
              <mat-select [formControl]="selectedLanguage">
                <mat-option *ngFor="let lang of languages" [value]="lang.value">
                  {{ lang.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      
      </div>
    </div>
    <!-- Buttons -->
    <div class="flex justify-end sticky !p-0 !bottom-0 !z-20">
      <button
        class="!bg-[#F1F3F5] !rounded-[3px] !text-[#E76B3F] w-[84px] h-[42px] mr-[15px] my-[10px]"
        mat-button
        mat-dialog-close
        style="border: 1px solid #e76b3f"
      >
        Cancel
      </button>
      <button
        class="!bg-[#E76B3F] !rounded-[3px] !text-white w-[84px] h-[42px] mr-[25px] my-[10px]"
        mat-button
        [mat-dialog-close]="true"
        (click)="uploadFile()"
      >
        Process
      </button>
    </div>
  </div>
</mat-dialog-content>
